const NS = 'WoolHeaderWidget';
const CLS = 'woolHeaderWidget';

export class WoolHeaderWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.autoSlide = this.$element.find(`.${CLS}-stats`).data(`tickerSlide`);
		if(this.autoSlide === "False"){
			this.autoSlide = false;
		}
		else{
			this.autoSlide = true;
		}
		

		$('.single-item').slick({
			autoplay: this.autoSlide,       //autoplay
			autoplaySpeed: 3000,  //autoplay speed
			speed: 800,           //slide speed
			arrows: true,         //arrows both sides of slide
			infinite: true,       //loop infinitely
		});

		this.$siteHeaderBottomMenuWidget = this.$element.find(`.siteHeaderBottomMenuWidget`);
		this.$siteHeaderBottomSearchBarWidget = this.$element.find(`.siteHeaderBottomSearchBarWidget`);
		this.$siteHeaderWidget = this.$element.parent(`.siteHeaderWidget`);
		$(document.body).append(this.$siteHeaderBottomMenuWidget);
		$(document.body).append(this.$siteHeaderBottomSearchBarWidget);


		this.$togglerButton = this.$element.find(`.${CLS}-btn--toggler`);
		this.$togglerButton.on('click', () => {
			if(!this.$togglerButton.hasClass('active')) {

				this.$siteHeaderBottomMenuWidget.trigger('siteHeaderBottomMenuWidget.open', {
					siteHeaderBottomWidget: this.$element
				});

				this.$togglerButton.addClass('active');
			}
			else {
				this.$siteHeaderBottomMenuWidget.trigger('siteHeaderBottomMenuWidget.close', {});
				this.$togglerButton.removeClass('active');
			}
		});

		//this.$searchBarButton = this.$element.find(`.${CLS}-btn--search`);
		this.$searchBarButton.on('click', () => {
			if(!this.$searchBarButton.hasClass('active')) {
				destroyItems({
					bottomMenu: true
				});

				this.$siteHeaderBottomSearchBarWidget.trigger('siteHeaderBottomSearchBarWidget.open', {
					siteHeaderBottomWidget: this.$element
				});

				this.$searchBarButton.addClass('active');
				this.$siteHeaderWidget.addClass(`siteHeaderWidget--activeElement`);
			}
			else {
				destroyItems({
					bottomMenu: true,
					searchBar: true
				});
			}
		});

		let destroyItems = (include) => {
			if(include.searchBar) {
				this.$siteHeaderBottomSearchBarWidget.trigger('siteHeaderBottomSearchBarWidget.close', {});
				this.$searchBarButton.removeClass('active');
			}
			if(include.bottomMenu) {
				this.$siteHeaderBottomMenuWidget.trigger('siteHeaderBottomMenuWidget.close', {});
				this.$togglerButton.removeClass('active');
			}
			this.$siteHeaderWidget.removeClass(`siteHeaderWidget--activeElement`);
		};

		this.initSticky();
	}

	initSticky() {
		let $element = this.$element;
		let $elementClone = null;
		let oldScrollY = 0;
		let scrollY;

		let toggleSticky = () => {
			let offsetTop = $('.woolHeaderWidget').first().offset().top;

			if(scrollY > offsetTop) {
				if(_.isNil($elementClone)) {
					$elementClone = $element.clone(true, true);
					$element.before($elementClone);

					$element.css({
						position: 'fixed',
						top: '0',
						left: '0',
						right: '0',
						zIndex: '100'
					});

					$elementClone.attr('wool-header-widget-placeholder-clone', 'true');
					$elementClone.css({
						visibility: 'hidden'
					});
				}
			}
			else {
				if($elementClone) {
					$elementClone.remove();
					$elementClone = null;

					$element.css({
						position: ''
					});
				}
			}
		};

		let initScrollEvents = () => {
			scrollY = Math.round(window.scrollY);
			toggleSticky();
			oldScrollY = scrollY;
		};

		$(window).on('scroll', _.debounce(() => {
			// Don’t trigger scrolling event when overlay is activated
			if(!$(document.body).hasClass('hasOverlay')) {
				initScrollEvents();
			}
		}, 50, { leading: true, trailing: true }));

		initScrollEvents();
	}
}
